import './section.styles.scss';

const Section = ({ icon, title, br, bg, clickHandler}) => {


	return(
		<div 
			className='section-box' 
			// style={{
			// 	border: `solid ${
			// 		bg === 'black' 
			// 		? 'black' 
			// 		: 'rgba(255,255,255,0.4'} 
			// 		0.5px`,
			// }}
			onClick={clickHandler}
		>
			<div className='section' style={{
				border: br,
				backgroundColor: bg
			}}>
				<span className='icon'>
					{icon}
				</span>
				<span className='text-box'>
					<h4 style={{
						color: 'white',
						fontSize: '1em',
						fontWeight: 'bold'
					}}>{title}</h4>
				</span>
			</div>
		</div>
	);
}

export default Section;